import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyJsdWidgetsRoute: InvariantJiraRoute = {
	name: 'legacy-jsd-widgets',
	path: '/servicedesk/admin/:projectKey/addon/:addonName',
	exact: true,
};
